import http from '../../config/axios';


export const allBenefits = () => {
    const res =  http.get('/benefit')
    return res;
}